import { render, staticRenderFns } from "./SearchComplaint.vue?vue&type=template&id=11294614"
import script from "./SearchComplaint.vue?vue&type=script&lang=js"
export * from "./SearchComplaint.vue?vue&type=script&lang=js"
import style0 from "./SearchComplaint.vue?vue&type=style&index=0&id=11294614&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports